<template>
  <div class="" v-if="isPropertyLoading">Loading...</div>

  <div v-else>
    <TrainingLayout :headline="`${property?.name} Emergency Response`">
      <section class="mt-8 video">Response steps for {{ responseSysName }} go here</section>
    </TrainingLayout>
  </div>
</template>

<script lang="ts" setup>
import { useBldgStore } from "../store/bldgStore";

const bldgStore = useBldgStore();
const route = useRoute();
var isPropertyLoading = computed(() => bldgStore.isLoading);
var property = computed(() => bldgStore.property);
let responseSysName = route.params.responseSysName;
console.log("Response Page loading response:" + responseSysName);

</script>
